import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from '../types/TCall';
import type { adminJobsKeys } from './adminJobsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof adminJobsKeys.transactionsByJob>>;

export const createFetchAdminJobTransactionsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId }], signal }: TParams) =>
    call(() => cancelOnSignal(AdminService.getJobTransactions({ jobId }), signal));
